import ActionsForm from '@/shared/mixins/actionsForm'
import GedFolderRepository from '@/shared/http/repositories/business/gedfolder'
import GedFolderChecklistTypeRepository from '@/shared/http/repositories/business/gedfolderchecklisttype'
import { loading, toast } from '@/shared/utils/UIHelper'
import Roles from '@/shared/utils/roles'
import FolderPermission from '@/shared/utils/folderPermission'
import AccountMixin from '@/store/module/account/mixin'
import Tools from '@/components/tools/Tools'
import FileTreeView from '../treeview/FileTreeView.vue'
import SearchForm from '../search/search-form'
import GedFileSearchModel from '@/shared/models/business/gedFilesearchmodel'
import DocMixin from '../../mixins/DocMixin'
import FoldersName from '../foldersname/foldersname'
import Transform from '../foldersname/transform'

export default {
  name: 'docmenu',
  mixins: [ DocMixin, ActionsForm, AccountMixin ],
  computed: {
    title () {
      if (this.isSearching) {
        if (this.showFavor) {
          return ''
        }
        return this.$lang.Documents.Menu.TitleForm + ' (...pesquisando)'
      }
      return this.$lang.Documents.Menu.TitleForm
    }
  },
  data () {
    return {
      folders: [],
      waiting: false,
      addingFolder: null,
      isUndeleting: false,
      firstOpen: true,
      isSearching: false,
      searchingPage: 1,
      searchingTotalPages: 0,
      showSettings: false,
      showFavor: false,
      roles: Roles,
      folderPermission: FolderPermission,
      searchForm: SearchForm,
      searchData: GedFileSearchModel,
      openedIds: [],
      isStructCopySet: false,
      structCopied: null,
      pages: null
    }
  },
  props: {
    selectFolder: {
      type: Boolean,
      default: false
    },
    startupFolderId: {
      type: String,
      default: null
    }
  },
  components: {
    FileTreeView,
    // Search,
    FoldersName
  },
  methods: {
    getIconBeforeName (folder) {
      if (folder.checkStatus !== undefined) {
        if (folder.checkStatus === -1) {
          return 'fas fa-exclamation-circle text-danger'
        } else if (folder.checkStatus === 0) {
          return 'fas fa-exclamation-circle text-warning'
        } else {
          return 'fas fa-check-circle text-info'
        }
      }
      return null
    },
    onLoad (isUndeleting, searchParams = {}) {
      this.isUndeleting = !!isUndeleting
      this.showSettings = false
      this.addingFolder = null

      loading.push()
      this.$refs.treeview.closeAll()

      if (this.startupFolderId) {
        return GedFolderRepository.Get(this.startupFolderId)
          .then(response => {
            if (response.data.code > 0) {
              response.data.data.gedPastas = []
              this.folders = [response.data.data]
              this.waiting = false
            }
          })
          .catch(err => console.log(err))
          .finally(() => loading.close())
      } else {
        this.openedIds = this.$refs.treeview.getOpenedIds()
        searchParams.limit = this.isUndeleting ? 100 : this.isSearching ? 50 : null
        searchParams.index = this.isUndeleting ? 1 : this.isSearching ? this.searchingPage++ : null
        searchParams.deleted = this.isUndeleting
        searchParams.favor = this.showFavor
        searchParams.rootOnly = !this.isUndeleting && !this.isSearching && !this.showFavor
        const params = {params: searchParams}
        return GedFolderRepository.GetAll(this.CompanySelected, params)
          .then(response => {
            if (response.data.code > 0) {
              this.searchingTotalPages = response.data.totalPages
              response.data.data.forEach(f => {
                const folder = this.folders.filter(fd => fd.id === f.id)[0]
                f.gedPastas = []
                if (folder && this.openedIds && this.openedIds.some(oi => oi === folder.id)) {
                  f.gedPastas = folder.gedPastas
                  this.onOpen(f)
                }
                if (this.isUndeleting) {
                  f.foldersName = Transform(f.nomePastas)
                }
              })
              if (this.isSearching) {
                this.folders.push(...response.data.data)
              } else {
                this.folders = response.data.data
              }
              this.waiting = false
              this.$emit(this.isUndeleting ? 'undelete' : 'clear')
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => loading.close())
      }
    },
    loadAllAndOpen (folder) {
      this.showFavor = false

      const _setOpen = (comp) => {
        if (comp.$refs['treeviewItem']) {
          var opn = false
          comp.$refs['treeviewItem'].forEach(ch => {
            if (ch.$options.name === 'TreeViewItem') {
              if (ch.item.checked) {
                opn = true
                return true
              } else {
                var op = _setOpen(ch)
                if (op) {
                  ch.open = true
                  opn = true
                  return true
                }
              }
            }
          })
          return opn
        }
      }

      return GedFolderRepository.GetAll(this.CompanySelected, false, false)
        .then(response => {
          if (response.data.code > 0) {
            this.folders = response.data.data
            this.$nextTick(() => {
              this.$refs.treeview.setChecked(folder)
              _setOpen(this.$refs.treeview)
            })
          }
        })
    },
    onFavoriteFolder (folder, favor) {
      loading.push()
      GedFolderRepository.UpdateFavor(folder.id, favor)
        .then(response => {
          if (response.data.code > 0) {
            folder.favorito = favor
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onEdit (folder) {
      this.addingFolder = {type: 'EDIT', folder: folder}
      this.waiting = true

      loading.push()
      GedFolderRepository.Get(folder.id)
        .then(response => {
          if (response.data.code > 0) {
            this.$set(folder, 'gedTipoID', response.data.data.gedTipoID)
            this.$set(folder, 'gedAssuntoID', response.data.data.gedAssuntoID)
            this.$set(folder, 'gedChecklistID', response.data.data.gedChecklistID)
            this.$set(folder, 'seguranca', response.data.data.seguranca)
            this.$set(folder, 'gedPastaGrupos', response.data.data.gedPastaGrupos)
            this.$set(folder, 'gedPastaContas', response.data.data.gedPastaContas)
            this.$set(folder, 'gedPastaTags', response.data.data.gedPastaTags ? response.data.data.gedPastaTags : [])
          }

          this.$nextTick(() => {
            this.$emit('edit', folder)
            this.openedIds = this.$refs.treeview.getOpenedIds()
          })
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onAdd (folder) {
      let newFolder
      if (!folder) {
        newFolder = {
          nome: 'Nova Pasta',
          gedPastas: []
        }
        this.folders.push(newFolder)
        this.addingFolder = {type: 'ADDROOT', folder: folder}
        this.waiting = true
        this.$emit('add', newFolder)
      } else {
        GedFolderRepository.Get(folder.id)
          .then(response => {
            if (response.data.code > 0) {
              const data = response.data.data

              newFolder = {
                id: '00000000-0000-0000-0000-000000000000',
                nome: 'Nova Pasta',
                gedPastaPaiID: folder.id,
                gedTipoID: data.gedTipoID,
                gedAssuntoID: data.gedAssuntoID,
                empresaID: this.CompanySelected,
                seguranca: data.seguranca,
                status: 1,
                gedPastaGrupos: data.gedPastaGrupos ? data.gedPastaGrupos.map(f => {
                  f.gedPastaID = '00000000-0000-0000-0000-000000000000'
                  f.id = '00000000-0000-0000-0000-000000000000'
                  return f
                }) : [],
                gedPastaContas: data.gedPastaContas ? data.gedPastaContas.map(f => {
                  f.gedPastaID = '00000000-0000-0000-0000-000000000000'
                  f.id = '00000000-0000-0000-0000-000000000000'
                  return f
                }) : [],
                gedPastaTags: data.gedPastaTags ? data.gedPastaTags.map(f => {
                  f.gedPastaID = '00000000-0000-0000-0000-000000000000'
                  f.id = '00000000-0000-0000-0000-000000000000'
                  return f
                }) : [],
                gedPastas: []
              }

              folder.gedPastas = folder.gedPastas || []

              folder.gedPastas.push(newFolder)
              this.$refs.treeview.setChecked(newFolder)
              this.addingFolder = {type: 'ADD', folder: folder}

              this.waiting = true
              this.openedIds = this.$refs.treeview.getOpenedIds()

              this.$emit('add', newFolder)
            }
          })
          .catch(err => this.onException(err))
      }
    },
    onUpdate (folder) {
      const updFolder = (fs, f) => {
        fs.forEach((fx, i) => {
          if (fx.id === f.id) {
            this.$set(fs, i, f)
          } else if (fx.gedPastas) {
            updFolder(fx.gedPastas, f)
          }
        })
      }
      updFolder(this.folders, folder)
      this.waiting = false
      this.addingFolder = null
      this.$nextTick(() => {
        this.reload(folder)
      })
    },
    onCreate (folder) {
      if (this.addingFolder.type === 'ADD') {
        this.addingFolder.folder.gedPastas.pop()
        this.addingFolder.folder.gedPastas.push(folder)
      } else {
        this.folders.pop()
        this.folders.push(folder)
      }
      this.addingFolder = null
      this.waiting = false
      this.$nextTick(() => {
        this.reload(folder)
      })
    },
    onBackSearch () {
      this.waiting = false
      this.isSearching = false
      this.showFavor = false
      this.searchingPage = 1
      this.folders = []
      this.onLoad()
    },
    onBack () {
      this.$emit('back')
      this.waiting = false
      this.isSearching = false
      this.showFavor = false
      this.showSettings = false
      this.addingFolder = null
      if (this.isUndeleting) {
        this.folders = []
        this.onLoad()
      }
    },
    onBackAddFolder (folder) {
      if (this.addingFolder) {
        if (this.addingFolder.type === 'ADDROOT') {
          this.folders.pop()
        } else if (this.addingFolder.type === 'ADD') {
          this.addingFolder.folder.gedPastas.pop()
        }
      }
      this.addingFolder = null
      this.waiting = false
      this.$nextTick(() => {
        if (folder) {
          this.$refs.treeview.setChecked(folder)
          this.onSelectItem(folder)
          this.openedIds = this.$refs.treeview.getOpenedIds()
        }
      })
    },
    onDelete (folder) {
      loading.push()
      GedFolderRepository.Delete(folder.id)
        .then(response => {
          if (response.data.code > 0) {
            // this.onLoad()
            this.reload(folder)
          } else {
            if (response.data.code === -900) {
              toast.error(response.data.resultException.Message)
            } else {
              toast.error(this.$lang.Common.ActionNotTaken)
            }
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUndeleteItem (folder) {
      loading.push()
      GedFolderRepository.Get(folder.id)
        .then(responseGet => {
          if (responseGet.data.code > 0) {
            const folderGet = responseGet.data.data
            folderGet.status = 1
            GedFolderRepository.Update(folderGet)
              .then(responseUpd => {
                if (responseUpd.data.code > 0) {
                  // this.onLoad(false)
                  this.reload(folder)
                } else {
                  toast.error(this.$lang.Common.ActionNotTaken)
                }
              })
              .catch(err => this.onException(err))
              .finally(() => loading.close())
          }
        })
        .catch(err => this.onException(err))
    },
    onUndelete () {
      this.onLoad(true)
    },
    onClose () {
      this.openedIds = this.$refs.treeview.getOpenedIds()
    },
    onOpen (folder) {
      if (folder) {
        this.openedIds = this.$refs.treeview.getOpenedIds()
        loading.push()
        GedFolderRepository.GetAllByFolder(folder.id)
          .then(response => {
            if (response.data.code > 0) {
              // if (this.startupFolderId && this.firstOpen) {
              //   response.data.data.forEach(f => {
              //     f.gedPastas = []
              //     if (this.isUndeleting) {
              //       f.foldersName = Transform(f.nomePastas)
              //     }
              //   })
              //   folder.gedPastas = response.data.data
              //   this.waiting = false
              //   this.firstOpen = false
              // } else {
              response.data.data.forEach(f => {
                f.gedPastas = []
                const fold = folder.gedPastas.filter(fd => fd.id === f.id)[0]
                if (fold && this.openedIds && this.openedIds.some(oi => oi === folder.id)) {
                  f.gedPastas = fold.gedPastas
                  this.onOpen(f)
                }
                this.fixOpen(f)
              })
              folder.gedPastas = response.data.data
              this.openedIds = this.$refs.treeview.getOpenedIds()
            }
            // }
          })
          .catch(err => this.onException(err))
          .finally(() => loading.close())
      }
    },
    fixOpen (folder) {
      if (folder.gedChecklistID) {
        GedFolderChecklistTypeRepository.GetChecklistStatus(folder.id)
          .then(responseCk => {
            if (responseCk.data.code > 0) {
              this.$set(folder, 'checkStatus', parseInt(responseCk.data.data))
            }
          })
      }
    },
    onSelectItem (folder) {
      loading.push()
      GedFolderRepository.Get(folder.id)
        .then(response => {
          if (response.data.code > 0) {
            this.$set(folder, 'gedTipoID', response.data.data.gedTipoID)
            this.$set(folder, 'gedAssuntoID', response.data.data.gedAssuntoID)
            this.$set(folder, 'seguranca', response.data.data.seguranca)
            this.$set(folder, 'gedPastaGrupos', response.data.data.gedPastaGrupos)
            this.$set(folder, 'gedPastaContas', response.data.data.gedPastaContas)
            this.$set(folder, 'gedPastaTags', response.data.data.gedPastaTags ? response.data.data.gedPastaTags : [])
          }

          const findFather = (fd, list) => {
            let founded = null
            list.forEach(f => {
              let searched = null
              if (f.id === fd) searched = f
              if (!searched && f.gedPastas && f.gedPastas.length) searched = findFather(fd, f.gedPastas)
              if (searched) founded = searched
            })
            return founded
          }

          const getPathName = fd => {
            if (fd.gedPastaPaiID) {
              let father = findFather(fd.gedPastaPaiID, this.folders)
              if (!father) return '.../' + fd.nome
              return getPathName(father) + '/' + fd.nome
            }
            return '/' + fd.nome
          }

          folder.pathName = getPathName(folder)

          this.$nextTick(() => {
            this.$emit('selectitem', folder)
          })
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onSearchFavor () {
      this.showFavor = true
      this.onSearch(true)
    },
    onSettings () {
      this.showSettings = true
      // this.onSelectItem()
      this.$emit('showSettings')
    },
    // onClickSearch () {
    //   this.$emit('clear')
    // },
    onSearch (clear) {
      Tools.SetValueToSave(this.searchForm, this.searchData)
      this.searchData.empresaID = this.CompanySelected
      // this.searchData.gedTagIDs = this.searchForm.gedTagID.selectedTags.map(f => {
      //   return f.value
      // })
      if (clear) this.folders = []
      this.isSearching = true
      this.onLoad(this.isUndeleting, this.searchData)
      // this.$emit('search', this.searchData)
    },
    onEndMove (folderId) {
      const result = this.findFolderHierarchy(this.folders, folderId)
      if (result) {
        if (result.parent) {
          this.onOpen(result.parent)
          this.onSelectItem(result.parent)
        } else {
          this.onLoad(false)
        }
      }
    },
    onStructCopy (item) {
      GedFolderRepository.GetStruct(item.id)
        .then(response => {
          this.structCopied = response.data.data
          this.isStructCopySet = true
        })
        .catch(err => this.onException(err))
    },
    onStructCopyExecute (item) {
      if (item) {
        loading.push()
        GedFolderRepository.CreateStruct(item.id, this.structCopied)
          .then(response => {
          })
          .catch(err => this.onException(err))
          .finally(() => {
            this.onLoad()
            loading.close()
          })
      } else {
        this.structCopied = null
        this.isStructCopySet = false
      }
    },
    reload (createdFolder) {
      let folder = this.findFolderHierarchy(this.folders, createdFolder.gedPastaPaiID)
      if (folder.parent) {
        this.onOpen(folder.parent)
      } else {
        this.onLoad(false)
      }
    },
    findFolderHierarchy: function (list, targetId) {
      function recursiveSearch (items, targetId, parent, grandparent) {
        if (!items || items.length === 0) return null
        for (var i = 0; i < items.length; i++) {
          var item = items[i]
          if (item.id === targetId) {
            return {
              folder: item,
              parent: parent || null,
              grandparent: grandparent || null
            }
          }
          if (item.gedPastas && item.gedPastas.length) {
            var found = recursiveSearch(item.gedPastas, targetId, item, parent)
            if (found) return found
          }
        }
        return null
      }
      return recursiveSearch(list, targetId, null, null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/menu/docmenu.js